import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import ElementSiteRichText from '@/elements/SiteRichText.vue';
import utils from '@/utils';
import type { SiteRichTextProps } from '@/types/components/SiteRichText';


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteRichText',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-site-rich-text'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

return (_ctx: any,_cache: any) => {
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value?.content?.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value)
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createVNode(ElementSiteRichText, {
              field: fields.value.content,
              class: "c-site-rich-text__content"
            }, null, 8, ["field"])
          ]),
          _: 1
        })
      ], 6))
    : _createCommentVNode("", true)
}
}

})